import { PAQUETES } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null,
    ventana_filtros: false
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case PAQUETES.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case PAQUETES.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case PAQUETES.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter( paquete => paquete.id !== payload )
            };

        case PAQUETES.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };

        default:
            return state;
    }
}
